/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React from 'react'
import DashboardIcon from '@material-ui/icons/DashboardOutlined'
import PeopleIcon from '@material-ui/icons/People';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PostAddIcon from '@material-ui/icons/PostAdd';
import BookmarksIcon from '@material-ui/icons/Bookmarks';
import ArchiveIcon from '@material-ui/icons/Archive';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import StarsIcon from '@material-ui/icons/Stars';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import ListAltIcon from '@material-ui/icons/ListAlt';

import {FormattedMessage} from "react-intl"

export default [
  {
    subheader: "Admin Controls",
    items: [
      {
        title: "Dashboard",
        href: '/dashboard',
        icon: DashboardIcon
      },
      {
        title: "Clients",
        href: '/clients',
        icon: PeopleIcon
      },
      {
        title: "Lawyers",
        href: '/lawyers',
        icon: AssignmentIndIcon
      },
      {
        title: "Orders",
        href: '/orders',
        icon: PostAddIcon,
        items: [
          {
            title: "Advice",
            href: '/orders/advice'
          },
          {
            title: "Issue",
            href: '/orders/issue'
          },
        ]
      },
      {
        title: "Refuse Offers",
        href: '/refuseoffers',
        icon: CancelPresentationIcon
      },
      {
        title: "Refused",
        href: '/refused',
        icon: CancelPresentationIcon
      },
      {
        title: "Rates",
        href: '/rates',
        icon: StarsIcon,
        items: [
          {
            title: "Clients",
            href: '/rates/clients'
          },
          {
            title: "Lawyers",
            href: '/rates/lawyers'
          },
        ]
      },
      {
        title: "Balances",
        href: '/balances',
        icon: MonetizationOnIcon,
      },
      {
        title: "Reports",
        href: '/reports',
      },
      {
        title: "Settings",
        href: '/settings',
        icon: SettingsApplicationsIcon,
        items: [
          {
            title: "General Settings",
            href: '/settings/general'
          },
          {
            title: "Rate Questions",
            href: '/settings/questions'
          },
          {
            title: "Countries",
            href: '/settings/countries'
          },
          {
            title: "Cities",
            href: '/settings/cities'
          },
          {
            title: "Languages",
            href: '/settings/languages'
          },
          {
            title: "Degrees",
            href: '/settings/degrees'
          },
          {
            title: "Specialties",
            href: '/settings/specialties'
          },
          {
            title: "Levels",
            href: '/settings/levels'
          },
          {
            title: "Banks",
            href: '/settings/banks'
          },
        ]
      },
      {
        title: "Lawyer",
        href: '/lawyer',
        icon: AccountCircleIcon,
        items: [
          {
            title: "Lawyer Profile",
            href: '/lawyer/profile',
          },
          {
            title: "Experiences",
            href: '/lawyer/experiences'
          },
          {
            title: "Qualifications",
            href: '/lawyer/qualifications'
          },
          {
            title: "Course",
            href: '/lawyer/courses'
          },
          {
            title: "Licenses",
            href: '/lawyer/licenses'
          },
          {
            title: "Memberships",
            href: '/lawyer/memberships'
          },
          {
            title: "My Account",
            href: '/lawyer/account'
          },
          {
            title: "My Rate",
            href: '/lawyer/rate'
          },
        ]
      },
      {
        title: "Invitations",
        href: '/invitations',
        icon: BookmarksIcon
      },
      {
        title: "Lawyer Orders",
        href: '/lawyerorders',
        icon: PostAddIcon,
        items: [
          {
            title: "Advice",
            href: '/lawyerorders/advice'
          },
          {
            title: "Issue",
            href: '/lawyerorders/issue'
          },
          {
            title: "Offers",
            href: '/lawyerorders/offer'
          },
        ]
      },
      {
        title: "Archive",
        href: '/archive',
        icon: ArchiveIcon
      },

      {
        title: "Lawyer Balance",
        href: '/lawyerbalance',
        icon: MonetizationOnIcon
      },
      {
        title: "User Management",
        href: '/users',
        icon: ListAltIcon,
        items: [
          {
            title: "Permissions",
            href: '/users/permissions'
          },
          {
            title: "Roles",
            href: '/users/roles'
          },
          {
            title: "Users",
            href: '/users/users'
          }
        ]
      }
    ]
  }
]
